const iosAppId = '6759037915';
const androidPackageName = 'de.impact_code.lalino';
export const APP_STORE_CONFIG = {
  iosAppId,
  iosAppDeUrl: `https://apps.apple.com/de/app/lalino/id${iosAppId}`,
  androidPackageName,
  androidAppUrl: `https://play.google.com/store/apps/details?id=${androidPackageName}`,
  appName: 'Lalino',
  tagline: $localize`Get our app in the app store`,
  iconPath: 'apple-touch-icon.png',
} as const;
